import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '../../assets/MenuIcon';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="bg-gunmetal text-white p-4 shadow-md">
      <div className="container mx-auto flex items-center justify-between">
        {/* Título de la aplicación */}
        <h1 className={`text-2xl font-bold ${isOpen ? 'mx-auto' : ''}`}>Inmotrust</h1>

        {/* Botón de menú hamburguesa para dispositivos móviles */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-white focus:outline-none"
        >
          {/* Icono de menú hamburguesa */}
          <MenuIcon className="w-6 h-6" />
        </button>

        {/* Menú de navegación */}
        <ul
          className={`flex flex-col md:flex-row md:space-x-6 absolute md:static top-16 left-0 w-full md:w-auto bg-gunmetal md:bg-transparent transition-transform ${
            isOpen ? 'block' : 'hidden md:flex'
          } z-50 md:z-auto`}
        >
          <li className="my-2 md:my-0 mx-4">
            <Link
              to="/"
              className="block py-2 px-4 rounded-lg hover:outline hover:outline-charcoal hover:bg-transparent transition-all"
              onClick={closeMenu} // Cierra el menú al hacer clic
            >
              Inicio
            </Link>
          </li>
          <li className="my-2 md:my-0 mx-4">
            <Link
              to="/servicios"
              className="block py-2 px-4 rounded-lg hover:outline hover:outline-charcoal hover:bg-transparent transition-all"
              onClick={closeMenu} // Cierra el menú al hacer clic
            >
              Servicios
            </Link>
          </li>
          <li className="my-2 md:my-0 mx-4">
            <Link
              to="/propiedades"
              className="block py-2 px-4 rounded-lg hover:outline hover:outline-charcoal hover:bg-transparent transition-all"
              onClick={closeMenu} // Cierra el menú al hacer clic
            >
              Propiedades
            </Link>
          </li>
          <li className="my-2 md:my-0 mx-4">
            <Link
              to="/sobreNosotros"
              className="block py-2 px-4 rounded-lg hover:outline hover:outline-charcoal hover:bg-transparent transition-all"
              onClick={closeMenu} // Cierra el menú al hacer clic
            >
              Sobre Nosotros
            </Link>
          </li>
          <li className="my-2 md:my-0 mx-4">
            <Link
              to="/contacto"
              className="block py-2 px-4 rounded-lg hover:outline hover:outline-charcoal hover:bg-transparent transition-all"
              onClick={closeMenu} // Cierra el menú al hacer clic
            >
              Contacto
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;